@if (formReady) {
<div class="type-panel">
    @if (formGroup()) {
    <form class="data-type-form" [formGroup]="formGroup()!" (ngSubmit)="onSubmit()">
        <div class="header">
            <ul class="tabs">
                @for (tab of tabs; track tab.caption) {
                <li class="tab" [hidden]="tab.hidden"><a class="tab-link" (click)="onClick(tab)"
                        [ngClass]="{'active': tabSelected === tab}">{{tab.caption}}</a></li>
                }
            </ul>
        </div>
        <div class="body">
            @if (node()?._id) {
            <div class="row">
                <div class="accordion">
                    @for (view of views; track view.meta.title) {
                    <app-expand [model]="view"></app-expand>
                    }
                </div>
            </div>
            }
        </div>
        <div class="footer">
            <div class="row">
                <button type="submit" class="button button-big" [disabled]="disabled">
                    <mat-icon class="regular-icon">save</mat-icon>
                </button>
            </div>
        </div>
    </form>
    }
</div>
}
